(() => {
 const grid = document.querySelector('#CollectionLoop');
 const pagination = document.querySelector('.pagination-custom');
 if (!grid || !pagination) {
   console.warn('Nie znaleziono siatki lub paginacji.');
   return;
 }
 if (window.phenotypeInfiniteScroll) {
   console.warn('Infinite scroll jest już uruchomiony.');
   return;
 }
 const getNext = (root) =>
   root.querySelector('.pagination-custom__next[href]');
 if (!getNext(pagination)) {
   console.info('Brak kolejnej strony produktów.');
   return;
 }
 window.phenotypeInfiniteScroll = true;
 const sentinel = document.createElement('div');
 sentinel.id = 'phenotype-scroll-trigger';
 sentinel.style.cssText = 'height:1px;width:100%';
 pagination.before(sentinel);
 let loading = false;
 let nextUrl = getNext(pagination).href;
 const visited = new Set([location.href]);
 const originalDisplay = pagination.style.display;
 const observer = new IntersectionObserver(async (entries) => {
   if (!entries[0].isIntersecting || loading || !nextUrl) return;
   loading = true;
   try {
     const url = new URL(nextUrl, location.href);
     if (url.origin !== location.origin || visited.has(url.href)) {
       throw new Error('Nieprawidłowy lub powtórzony adres strony');
     }
     console.log('Ładowanie:', url.href);
     const response = await fetch(url.href, {
       credentials: 'same-origin'
     });
     if (!response.ok) {
       throw new Error('HTTP ' + response.status);
     }
     const html = await response.text();
     const doc = new DOMParser().parseFromString(html, 'text/html');
     const newGrid = doc.querySelector('#CollectionLoop');
     const newPagination = doc.querySelector('.pagination-custom');
     if (!newGrid || !newPagination) {
       throw new Error('Brak siatki lub paginacji w odpowiedzi');
     }
     const products = Array.from(
       newGrid.querySelectorAll(':scope > .grid-item.product-item')
     );
     if (!products.length) {
       throw new Error('Nie znaleziono nowych produktów');
     }
     grid.append(...products);
     visited.add(url.href);
     const nextLink = getNext(newPagination);
     nextUrl = nextLink ? nextLink.href : null;
     if (!nextUrl) {
       observer.disconnect();
       sentinel.remove();
       pagination.remove();
       console.log('Wszystkie produkty załadowane.');
     } else {
       pagination.innerHTML = newPagination.innerHTML;
     }
     console.log('Dodano produktów:', products.length);
   } catch (error) {
     console.error('Infinite scroll:', error);
     observer.disconnect();
     sentinel.remove();
     pagination.style.display = originalDisplay;
     window.phenotypeInfiniteScroll = false;
   } finally {
     loading = false;
   }
 }, {
   rootMargin: '600px 0px',
   threshold: 0
 });
 pagination.style.display = 'none';
 observer.observe(sentinel);
 console.log('Infinite scroll aktywny!');
})();
